import { useCustomerQuery, type UseCustomerQueryResult } from '@/hooks/useCustomerQuery'

import { fetchQuestions, type CustomerQuestion } from '../lib/api'

export const ACCOUNTING_QUESTIONS_KEY = 'accounting-questions'
/** How stale the count may get on a visible tab: a question staff ask mid-session shows within this. */
const QUESTIONS_REFRESH_MS = 60_000

/**
 * The one write a customer is allowed to make starts here (v1 spec §11). The questions page, the
 * Overview, the dashboard card and the sidebar count all read this one cached list, so an answer
 * that ends in `refreshCustomerQuery(ACCOUNTING_QUESTIONS_KEY)` updates every one of them. Page
 * changes reuse the cached list; a visible tab reads it again each minute and on return to the tab.
 */
export function useAccountingQuestions({ enabled = true }: { enabled?: boolean } = {}): UseCustomerQueryResult<{
  questions: CustomerQuestion[]
}> {
  return useCustomerQuery({
    cacheKey: ACCOUNTING_QUESTIONS_KEY,
    queryFn: fetchQuestions,
    enabled,
    refreshWhileVisibleMs: QUESTIONS_REFRESH_MS,
  })
}
